/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetAsPayedModelTable as DigiworkMaitreDPosDtoOrderSetAsPayedModelTable } from '../../models/Digiwork/MaitreD/Pos/DTO/Order/set-as-payed-model-table';

export interface SetOrderBillAsPayedForTable$Params {
      body?: DigiworkMaitreDPosDtoOrderSetAsPayedModelTable
}

export function setOrderBillAsPayedForTable(http: HttpClient, rootUrl: string, params?: SetOrderBillAsPayedForTable$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setOrderBillAsPayedForTable.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setOrderBillAsPayedForTable.PATH = '/api/wtr/OrderBill/setorderbillaspayedfortable';
